
import { defineComponent, PropType, ref, watch, toRefs } from "vue";

export default defineComponent({
  name: "HouseItem",
  props: {
    list: {
      type: Array as PropType<Array<any>>,
      required: true
    },
    checked: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props, { emit }) {
    const checkedHouse = ref<any>({ id: "" });
    const { checked } = toRefs(props);

    watch(
      () => checked.value,
      val => {
        checkedHouse.value = val;
      }
    );

    const onClick = (user: any) => {
      if (user.lists.length) return;
      checkedHouse.value = user;
      emit("change", user);
    };

    const updateChecked = (val: any) => {
      checkedHouse.value = val;
      emit("change", val);
    };

    return {
      checkedHouse,
      onClick,
      updateChecked
    };
  }
});
